import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import './DealDetails.css';
import Footer from "../../Footer";
import { Link, useParams, useNavigate } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
import Topbar from "../../Topbar";
import loader from '../../../assests/loader.gif';
import Modal from 'react-bootstrap/Modal';
import API from '../../../Utils/Api';
import moment from "moment";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { gettoastsuccess, gettoastwarning } from '../../../Utils/Common';
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "300px",
};

const DealDetails = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [loading, setLoading] = useState(true);

    const [inputs, setInputs] = useState({
        deal_id: '', business_id: '', total_reviews: 0, beat_online_price: 'no', deal_end_date: '', listing_title: '', description: '', home_delivery: 0, online_price: '', online_link: '', deal_master_type: '', deal_type: '', amount: 0, discount: 0, original_mrp: '', business_name: '', address: '', business_contact_number: '', sale_price: '', buy_qty: '', get_qty: '', store_percent_discount: '', store_cash_discount: '', category_name: '', subcategory_name: '', is_deal_clipped: false, is_liked: false, is_dis_liked: false, total_like: 0, total_dis_like: 0,slug:'',website:'',free_item:''
    });
    const [like, setLike] = useState([]);
    const [dislike, setDislike] = useState([]);

    const [images, setImages] = useState([]);

    const [center, setCenter] = useState({
    lat: null,
    lng: null,
  });


    var adsetting = {
        dots: true,
        arrow: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,              // Enable autoplay
        autoplaySpeed: 3000,         // Set the speed for autoplay (in milliseconds)
        centerMode: false,
        adaptiveHeight: true,            // Enable center mode    
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };


    useEffect(() => {
        document.title = `Deal Details | Local Bells`;
        document.getElementById('bodywrap').className = 'nededetdetail';
        let formData = new FormData();
        formData.append('deal_id', id);
        var url = 'get_deal_detail_with_out_login_user';
        if (localStorage.getItem("token")) {
            url = 'get_deal_detail_with_login_user';
        }
        API.post(url, formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {

                } else {
                    var beat_online_price = 'no';
                    if (response.data.data.deal_master_type === 'specific') {
                        beat_online_price = response.data.data.beat_online_price;
                    }
                    var home_delivery = 0;
                    if (response.data.data.deal_master_type === 'specific') {
                        home_delivery = response.data.data.home_delivery;
                    }

                    setInputs({
                        deal_id: response.data.data.deal_id,
                        business_id: response.data.data.business_id,
                        total_reviews: response.data.data.total_reviews,
                        beat_online_price: beat_online_price,
                        deal_end_date: response.data.data.deal_end_date,
                        listing_title: response.data.data.listing_title,
                        description: response.data.data.description,
                        home_delivery: home_delivery,
                        online_price: response.data.data.online_price,
                        online_link: response.data.data.online_link,
                        deal_master_type: response.data.data.deal_master_type,
                        deal_type: response.data.data.deal_type,
                        amount: response.data.data.amount,
                        discount: response.data.data.discount,
                        original_mrp: response.data.data.original_mrp,
                        business_name: response.data.data.business_name,
                        address: response.data.data.address,
                        business_contact_number: response.data.data.business_contact_number,
                        sale_price: response.data.data.sale_price,
                        buy_qty: response.data.data.buy_qty,
                        get_qty: response.data.data.get_qty,
                        store_percent_discount: response.data.data.store_percent_discount,
                        store_cash_discount: response.data.data.store_cash_discount,
                        category_name: response.data.data.category_name,
                        subcategory_name: response.data.data.subcategory_name,
                        is_deal_clipped: response.data.data.is_deal_clipped,
                        is_liked: response.data.data.is_liked,
                        is_dis_liked: response.data.data.is_dis_liked,
                        total_like: response.data.data.total_like,
                        total_dis_like: response.data.data.total_dis_like,
                        slug:response.data.data.slug,
                        website:response.data.data.website,
                        free_item:response.data.data.free_item,
                    });
                    if(response.data.data.latitude!=='' && response.data.data.longitude!=='')
                    {
                        setCenter({
                            lat: response.data.data.latitude,
                            lng: response.data.data.longitude,
                          });
                    }
                    setLike(response.data.data.like);
                    setDislike(response.data.data.dislike);

                    setImages(response.data.data.deal_images);
                }
            }).catch(error => {
                setLoading(false);
            });

    }, [id]);

    // State to toggle sidebar visibility

    // console.log(inputs.is_deal_clipped)

    // Function to toggle sidebar visibility


    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [show2, setShow2] = useState(false);

    const handleClose2 = () => setShow2(false);
    const handleShow2 = () => setShow2(true);

    const handleYes = (e) => {
        e.preventDefault();

        if (!localStorage.getItem("token")) {
            navigate('/neighbour/login');
            return;
        }

        let deal_id = inputs.deal_id;

        let formData = new FormData();
        formData.append('deal_id', deal_id);
        API.post('deal_clipped', formData)
            .then(response => {
                if (response.data.status === false) {
                    //setError(response.data.message);
                    setShow2(false)
                    gettoastwarning(response.data.message, '');
                } else {
                    setShow2(false)
                    gettoastsuccess(response.data.message, '');
                    if (response.data.status === true) {
                        // console.log('deal_clipped_id ' + response.data.data.deal_clipped_id);
                        navigate('/neighbour/transaction-completion/' + response.data.data.deal_clipped_id);
                    }

                }
            }).catch(error => {
                setLoading(false);
                gettoastwarning("Something went wrong. Please try again later.", '');
            });

    };

    const handleLikeDislike = (eventKey, dealId, type) => {

        if (!localStorage.getItem("token")) {
            navigate('/neighbour/login');
            return;
        }

        let formData = new FormData();
        formData.append('deal_id', dealId);
        formData.append('type', type);
        formData.append('like_dislike_id', eventKey);
        var url = 'deal_like_dislike_by_user';

        API.post(url, formData)
            .then(response => {
                if (response.data.status === false) {

                } else {
                    // console.log('Like success '+ response.data.data.total_like);
                    // console.log('Dislike success '+ response.data.data.total_dis_like);

                    setInputs(prev => ({
                        ...prev, 
                        is_liked: response.data.data.is_liked,
                        is_dis_liked: response.data.data.is_dis_liked,
                        total_like: response.data.data.total_like,
                        total_dis_like: response.data.data.total_dis_like,
                        total_reviews: response.data.data.total_reviews,
                    }));

                    setLike(response.data.data.like);
                    setDislike(response.data.data.dislike);

                }
            }).catch(error => {
                setLoading(false);
                console.error('Error :', error);
            });
    };

    const handleCopy = () => {
        const url = inputs.business_contact_number;
        navigator.clipboard.writeText(url)
            .then(() => {
                gettoastsuccess('Link copied to clipboard', '');
            })
            .catch(err => {
                console.error('Failed to copy:', err);
            });
    }
    const handleWhatapp = () => {
        const url = window.location.href;
        const phoneNumber = '+91'+inputs.business_contact_number;
        const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(url)}`;

        window.open(whatsappURL, "_blank");
    }
    const shareAll = () => {
        const url = window.location.href;

        navigator.clipboard.writeText(url)
            .then(() => {
                gettoastsuccess('Link copied to clipboard', '');
            })
            .catch(err => {
                console.error('Failed to copy:', err);
            });
    }

    


    return (
        <>
            <Topbar />
            <section className="main-cont-box">
                <Container>
                    <Row>
                        {/* <NeighbourSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible} />*/}
                        <Col md={12} lg={12} xl={12} xxl={12} className='main-cont-box-right'>
                            {/*<Header toggleSidebar={toggleSidebar} />*/}
                            <div className='nei-cont'>
                                <Row className="justify-content-center">
                                    <Col lg={9} xl={7}>
                                        <div className='white-box '>

                                            <Row>
                                                <div className="d-flex align-items-start justify-content-between gap-3">

                                                    <div className="dd-tag">
                                                        <Link to="">{inputs.category_name}</Link>
                                                        <p> <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/right-arrow.webp'} className="img-fluid" alt="right-arrow" /> </p>
                                                        <Link to="">{inputs.subcategory_name}</Link>
                                                    </div>
                                                    {
                                                      localStorage.getItem("page") && localStorage.getItem("page") === "1" ? (
                                                        <Link to="/deal"  className='cross-up'>
                                                          <Image
                                                            src={process.env.REACT_APP_BASE_URL + 'assets/images/cross.webp'}
                                                            className="img-fluid crosy"
                                                            alt="wp"
                                                          />
                                                        </Link>
                                                      ) : (
                                                        <Link to="#" onClick={() => navigate(-1)} className='cross-up'>
                                                          <Image
                                                            src={process.env.REACT_APP_BASE_URL + 'assets/images/cross.webp'}
                                                            className="img-fluid crosy"
                                                            alt="wp"
                                                          />
                                                        </Link>
                                                      )
                                                    }
                                                </div>
                                                <Col xs={12} className=''>
                                                    <div className='dd-ld-box'>
                                                        <Dropdown onSelect={(eventKey) => handleLikeDislike(eventKey, inputs.deal_id, 'like')}>
                                                            <Dropdown.Toggle className={`dd-like-box ${inputs.is_liked ? "like-box-bg" : "dlike-box-bg"}`} variant="success" id="dropdown-like">
                                                                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/like.webp'} className="img-fluid" alt="like" />
                                                                <h6>{inputs.total_like}</h6>
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu className='dd-like-drop'>
                                                                <div className='dislikecol'>
                                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/likecol.webp'} className="img-fluid" alt="like" />
                                                                    <h4>{inputs.total_like}</h4>
                                                                </div>
                                                                {like.map((val1, index1) => {
                                                                    return (
                                                                        <Dropdown.Item className={val1.is_liked ? 'active-like' : ''} eventKey={val1.id}><div><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/like.webp'} className="img-fluid" alt="like" /> {val1.name} </div><span>{val1.like_count}</span></Dropdown.Item>
                                                                    );
                                                                })}

                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                        <Dropdown onSelect={(eventKey) => handleLikeDislike(eventKey, inputs.deal_id, 'dislike')}>
                                                            <Dropdown.Toggle className={`dd-dislike-box ${inputs.is_dis_liked ? "like-box-bg" : "dlike-box-bg"}`} variant="success" id="dropdown-dislike">
                                                                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/dislike.webp'} className="img-fluid" alt="dislike" />
                                                                <h6>{inputs.total_dis_like}</h6>
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu className='dd-dislike-drop'>
                                                                <div className='dislikecol'>
                                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/dislikecol.webp'} className="img-fluid" alt="dislike" />
                                                                    <h4>{inputs.total_dis_like}</h4>
                                                                </div>
                                                                {dislike.map((val1, index1) => {
                                                                    return (
                                                                        <Dropdown.Item className={val1.is_disliked ? 'active-dislike' : ''} eventKey={val1.id}><div><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/dislike.webp'} className="img-fluid" alt="dislike" />{val1.name} </div><span>{val1.dislike_count}</span></Dropdown.Item>
                                                                    );
                                                                })}

                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                        <div className='dd-hp-icn'>
                                                            <Link to="" onClick={handleShow}>
                                                                <h6>{inputs.total_reviews} Reviews</h6>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <div className='dd-img-box mt-2'>
                                                <div className='dd-bop'>
                                                    {inputs.beat_online_price === 'yes' ? (
                                                        <h6>Beat Online Price</h6>
                                                    ) : null}
                                                </div>
                                                {images.length > 0 && (
                                                    <>
                                                        <div className='share-bd-main'>

                                                            <Link to="#" onClick={shareAll} className='blue-icn-btn share-bd share-bd-new'><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/share-th.webp'} className="img-fluid" alt="share-wh" /> </Link>

                                                            {/*<Image src={inputs.image} className="img-fluid dd-banner dd-banner-height" alt="dd-banner" />*/}
                                                            {images.length === 1 ? (
                                                                <Image
                                                                    src={images[0].image}
                                                                    className="img-fluid w-100"
                                                                    alt="ad-banner"
                                                                />
                                                            )  : (
                                                                <Slider {...adsetting} className="slider-deal-add">
                                                                    {images.map((val1, index1) => {
                                                                        return (<>
                                                                            <Image src={val1.image} className="img-fluid bd-banner" alt="ad-banner" /></>
                                                                        );
                                                                    })}
                                                                </Slider>
                                                            )}
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                            <Row>
                                                <Col xs={12} sm className='dd-cont-left mt-2'>

                                                    {(() => {
                                                        if (inputs.deal_master_type === 'specific') {
                                                            if (inputs.deal_type === 1) {
                                                                return (<div className='d-flex align-center csb-title'>
                                                                    <div className='d-flex'><strike className="me-2"><h5>Rs. {inputs.original_mrp}</h5></strike><h5>Rs. {inputs.sale_price}</h5></div>
                                                                    <h6 class="peroff">{inputs.discount}% off</h6>
                                                                </div>)
                                                            } else if (inputs.deal_type === 2) {
                                                                return (<div className='d-flex align-center csb-title'>
                                                                    <div className='d-flex'><h5>Buy {inputs.buy_qty} Get {inputs.get_qty}</h5></div>
                                                                </div>)
                                                            }
                                                        } else if (inputs.deal_master_type === 'general') {
                                                            if (inputs.deal_type === 3) {
                                                                return (<div className='d-flex align-center csb-title'>
                                                                    <div className='d-flex'><h5>{inputs.store_percent_discount}% OFF</h5></div>
                                                                </div>)
                                                            } else if (inputs.deal_type === 4) {
                                                                return (<div className='d-flex align-center csb-title'>
                                                                    <div className='d-flex'><h5>{inputs.store_cash_discount} OFF</h5></div>
                                                                </div>)
                                                            }
                                                        } else if (inputs.deal_master_type === 'free') {
                                                            return (<div className='d-flex align-center csb-title'>
                                                                <div className='d-flex'><h5 className="text-danger">{inputs.free_item}</h5></div>
                                                            </div>)
                                                        }
                                                    })()}

                                                    <h3 className='my-2'>{inputs.listing_title}</h3>
                                                    {inputs.deal_end_date !== '' && (
                                                        <h6 className='dd-left-date'>Deal Expires : {moment(inputs.deal_end_date).format("D MMMM, YYYY")}</h6>
                                                    )}
                                                </Col>
                                            </Row>
                                            {!inputs.is_deal_clipped && (
                                              <>
                                                <h5 className="fw-600 mt-3">Details:</h5>
                                                <div>
                                                  <div>
                                                    <div
                                                      dangerouslySetInnerHTML={{
                                                        __html: inputs.description.replace(/\n/g, "<br/>"),
                                                      }}
                                                    ></div>
                                                  </div>
                                                </div>
                                              </>
                                            )}

                                            {inputs.home_delivery ? (
                                                <>
                                                    <Row>
                                                        <Col md={12}>
                                                            <div className="dd-back-box">
                                                                <h6>Delivery Options:</h6>
                                                                <h6 className="fw-500">Home Delivery By Seller</h6>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </>
                                            ) : null}
                                            {inputs.deal_master_type === 'specific' && (
                                              <>
                                                {(inputs.online_link !== '' || inputs.online_price !== '') && (
                                                  <Row>
                                                    <Col md={12}>
                                                      <div className='dd-back-box'>
                                                        <h6>Online competitor</h6>
                                                        <div className='dd-single-row gap-3'>
                                                          <h6 className='fw-500 mb-0 flex-fill text-break'>
                                                            <Link to={inputs.online_link} className="text-decoration-none">{inputs.online_link}</Link>
                                                          </h6>
                                                          <h6 className='fw-500 mb-0 flex-shrink-0'>
                                                            RS. {inputs.online_price}
                                                          </h6>
                                                        </div>
                                                      </div>
                                                    </Col>
                                                  </Row>
                                                )}
                                              </>
                                            )}

                                            <Row>
                                                <Col md={12}>
                                                    <h5 className='fw-600 mt-3'>Business Details: </h5>
                                                </Col>
                                                <Col md={12}>
                                                    <div className='dd-mobile-box'>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/business.webp'} className="img-fluid" alt="business" />
                                                        <h6 className='mb-0'><Link to={`/neighbour/business-details/${inputs.slug}`}>{inputs.business_name}</Link></h6>
                                                    </div>
                                                </Col>
                                                <Col md={12}>
                                                    <div className='dd-mobile-box'>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/map-dd.webp'} className="img-fluid" alt="map-dd" />
                                                        <h6 className='mb-0'>{inputs.address}</h6>
                                                    </div>
                                                </Col>
                                                <Col md={12}>
                                                    <Row>
                                                        <Col md={12} className='dd-cpy-icn'>
                                                            <Row>
                                                                <Col xs="auto" className='dd-mobile-box'>
                                                                    <h6><span className='fw-500'>Contact :</span> {inputs.business_contact_number}</h6>
                                                                </Col>
                                                                <Col xs="auto">
                                                                    <Link to="#" onClick={handleCopy}>
                                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/copy.webp'} className="img-fluid" alt="copy" />
                                                                        <h6>Copy</h6>
                                                                    </Link>
                                                                </Col>
                                                                <Col xs="auto">
                                                                    <Link to={`tel:${inputs.business_contact_number}`}>
                                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/call.webp'} className="img-fluid" alt="call" />
                                                                        <h6>Call</h6>
                                                                    </Link>
                                                                </Col>
                                                                <Col xs="auto">
                                                                    <Link to="#" onClick={handleWhatapp}>
                                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/whatsapp-round.webp'} className="img-fluid" alt="whatsapp-round" />
                                                                        <h6>WhatsApp</h6>
                                                                    </Link>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                {inputs.website !== '' && (
                                                <Col md={12}>
                                                    <div className='dd-mobile-box'>
                                                        <h6><span className='fw-500'>Website :</span> {inputs.website}</h6>
                                                    </div>
                                                </Col>
                                                )}
                                            </Row>
                                            {center.lat !== null && center.lng !== null && (
                                              <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY}>
                                                <GoogleMap
                                                  mapContainerStyle={containerStyle}
                                                  center={center}
                                                  zoom={15}
                                                >
                                                  <Marker position={center} />
                                                </GoogleMap>
                                              </LoadScript>
                                            )}
                                            {/*<Image src={process.env.REACT_APP_BASE_URL + 'assets/images/map.webp'} className="img-fluid dd-map" alt="map" />*/}
                                            {/* <Link to="/neighbour/transaction-completion" className='blue-link' >Clip the Deal</Link> */}
                                            {inputs.is_deal_clipped === false ? (
                                              <>
                                                <Link className="blue-link" onClick={handleShow2}>
                                                  Reserve the Deal
                                                </Link>

                                                <h6 className="mt-2 text-center">
                                                  No payment now. Pay directly at Merchant when you redeem.
                                                </h6>
                                              </>
                                            ) : (
                                              <h5 className="mt-4 text-center">
                                                You have already clipped this deal. Go to My Deals to redeem the deal.
                                              </h5>
                                            )}
                                        </div>
                                    </Col>
                                </Row>

                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <Footer />

            <Modal
                show={show}
                size="lg"
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Reviews</Modal.Title>
                </Modal.Header>
                <Modal.Body className='review-modal'>
                    <Row>
                        <Col xs={12} lg={6} className='review-like'>
                            <div className='dislikecol'>
                                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/gr-emoji.webp'} className="img-fluid" alt="gr-emoji" />
                                <h4>{inputs.total_like}</h4>
                            </div>

                            {like.map((val1, index1) => {
                                return (<div key={index1}>
                                    <div>
                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/like.webp'} className="img-fluid" alt="like" />{val1.name}</div>
                                    <span>{val1.like_count}</span>
                                </div>)
                            })}

                        </Col>
                        <Col xs={12} lg={6} className='review-dislike'>
                            <div className='dislikecol'>
                                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/re-emoji.webp'} className="img-fluid" alt="re-emoji" />
                                <h4>{inputs.total_dis_like}</h4>
                            </div>

                            {dislike.map((val1, index1) => {
                                return (<div key={index1}>
                                    <div>
                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/dislike.webp'} className="img-fluid" alt="like" />{val1.name}</div>
                                    <span>{val1.dislike_count}</span>
                                </div>)
                            })}

                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>

            <Modal
                show={show2}
                onHide={handleClose2}
                backdrop="static"
                keyboard={false}
                centered
                className='redeem-modal'
            >
                <Modal.Body>
                    <Row>
                        <Col md={12}>
                            <h3 className='text-center'>Do you confirm to Reserve the Deal?</h3>
                        </Col>
                        <Col md={6}>
                            <Link to="" onClick={handleClose2} className='grey-link'>No</Link>
                        </Col>
                        <Col md={6}>
                            <Link to="" onClick={handleYes} className='blue-link'>Yes</Link>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
            {loading && (
                <div className="loadingClass">
                    <img src={loader} alt="loader" />
                </div>
            )}
        </>
    )
}

export default DealDetails;


